import { Http } from "../Http";
import { WaitlistWaitWhileStatus } from "../../../Integrations/WaitWhile/Model/WaitlistWaitWhileStatus.csharp";
import { WaitlistCenterOpeningStatus } from "../../Blocks/Waitlist/WaitlistCenterOpeningStatus.csharp";
import { UpdateWaitlistRequestDto } from "../../../Api/Model/UpdateWaitlistRequestDto.csharp";
import { EditableWaitlistViewModel } from "../../Blocks/Waitlist/EditableWaitlistViewModel.csharp";

export interface IWaitWhileApi {
  getWaitWhileStatus(contentId: number): Promise<WaitlistWaitWhileStatus>;
  getRegistrationStatus(
    contentId: number
  ): Promise<WaitlistCenterOpeningStatus>;
}

export class WaitWhileApi implements IWaitWhileApi {
  getWaitWhileStatus(contentId: number): Promise<WaitlistWaitWhileStatus> {
    return Http.get(
      `/api/waitlist/waitwhile-status/${contentId}`
    ) as Promise<WaitlistWaitWhileStatus>;
  }

  getRegistrationStatus(
    contentId: number
  ): Promise<WaitlistCenterOpeningStatus> {
    return Http.get(
      `/api/waitlist/registration-status/${contentId}`
    ) as Promise<WaitlistCenterOpeningStatus>;
  }

  updateWaitlist(request: UpdateWaitlistRequestDto): Promise<EditableWaitlistViewModel> {
    return Http.post(`/api/waitlist`, request) as Promise<EditableWaitlistViewModel>;
  }
}
